import { getReportTypeFunction } from '@/modules/adjusterReportModules/adjusterReport/queries/policeReport/getReportType/getReportTypeQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const getReportTypeQueryOptions = () => {
  return queryOptions({
    queryKey: ['getReportType'],
    queryFn: () => getReportTypeFunction(),
    enabled: true,
    select: (data) => {
      if (data) {
        return data.map(({ const: constArg, fa_const }) => ({
          label: fa_const,
          value: constArg,
        }));
      }
    },
  });
};
